// extracted by mini-css-extract-plugin
export default {"loginByPhoneContainer":"LoginByPhone_loginByPhoneContainer__vtxjY","customHeader":"LoginByPhone_customHeader__jtGyW"};